
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 154.1 110.94"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('rect',{attrs:{"y":"15.33","width":"138.05","height":"79.93","rx":"23.75","fill":"#87cea3"}}),_c('circle',{attrs:{"id":"path4138","cx":"21.16","cy":"72.21","r":"3.6"}}),_c('path',{attrs:{"id":"path4144","d":"M26 74.52V33.79h6.88v14.38c10.29-2.89 14.85 1.15 17.87 7 4.94-12.13 24.68-11.8 23.67 8.48H56.69c1.23 9.49 11.51 7.62 14.83 5l2 4.58c-12.12 7.94-20.93.61-23.14-5.21-2.84 3.75-8.53 12.17-24.38 6.5z","fill-rule":"evenodd"}}),_c('path',{attrs:{"id":"path4146","d":"M32.92 54.07c16.43-6.41 15.84 21.12 0 16.26z","fill":"#f9e819","fill-rule":"evenodd"}}),_c('path',{attrs:{"id":"path4150","d":"M56.28 58.94c0-9.06 11.24-8.69 11.24 0z","fill":"#e2141a","fill-rule":"evenodd"}}),_c('path',{staticClass:"belgian-eid-5",attrs:{"d":"M81.83 33.79h6.8v43h-6.8zM91.31 33.79h12.1c12.14 0 17.09 7 17.09 20.53 0 14.55-4.65 22.47-17.8 22.47H91.31zM98 71.27h4.59c7.56 0 11.09-5.11 11.09-16.87 0-10.41-3.52-15-11-15H98z"}}),_c('path',{attrs:{"d":"M115.39 0H99.28v12h16.11a26.75 26.75 0 0126.71 26.72v33.5a26.75 26.75 0 01-26.71 26.72H99.28v12h16.11a38.76 38.76 0 0038.71-38.72v-33.5A38.76 38.76 0 00115.39 0z"}})])])])
          )
        }
      }
    